import HttpHelpers from './helpers';

const PurcahsesApiEndpoints = {
  purchaseQuote: (data?: any) => HttpHelpers.authenticatedAxios
    .post('/api/v1/purchases/quote', data)
    .then((response) => response.data.data.attributes),
  purchaseCheckout: (data: any) => HttpHelpers.authenticatedAxios
    .post('/api/v1/purchases/checkout', data)
    .then((response) => response.data.data),
  getPurchaseDetails: (id: string) => HttpHelpers.authenticatedAxios
    .get(`/api/v1/purchases/${id}`)
    .then((response) => response.data.data.attributes),
};

export default PurcahsesApiEndpoints;
